import PropTypes from 'prop-types';
import React from 'react';
import { localDate } from 'utils/LocalDateTimeHelper';
import FootballMatchFormMatch from '../components/FootballMatchFormMatch';

export default function FootballMatchForm(props) {
  require('./FootballMatchForm.scss');

  return (
    <div className="teamMatchForm">
      <ul className="formMatches">
        {props.formMatches.map(match => (
          <li key={match.match_reference.id} className="rowListElement">
              <div className="matchDate">{localDate(match.match_date)}</div>
              <FootballMatchFormMatch match={match} />
          </li>
        ))}
      </ul>
    </div>
  );
}

FootballMatchForm.propTypes = {
  formMatches: PropTypes.array.isRequired
}



// WEBPACK FOOTER //
// ./modules/Football/components/FootballMatchForm.js